(function () {
  'use strict';
  var root = (window.routes && window.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* Mobile menu */
  var nav = document.querySelector('[data-menu]');
  var scrim = document.querySelector('.nav-scrim');
  var burger = document.querySelector('.hdr__burger');
  document.querySelectorAll('[data-menu-toggle]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (!nav) return;
      var open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      if (scrim) scrim.hidden = !open;
      if (burger) burger.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  });

  /* Close desktop dropdowns on outside click */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.nav__dd[open], .search-dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* Collection sorting */
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Money format */
  var fmtEl = document.querySelector('[data-money-format]');
  var moneyFormat = fmtEl ? JSON.parse(fmtEl.textContent) : '{{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  /* Product page */
  var pdp = document.querySelector('[data-product]');
  if (pdp) {
    var json = pdp.querySelector('[data-product-json]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var form = pdp.querySelector('[data-product-form]');
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var wrap = pdp.querySelector('[data-price-wrap]');
    var badge = pdp.querySelector('[data-badge]');
    var addBtn = pdp.querySelector('[data-add]');

    function showMedia(id) {
      pdp.querySelectorAll('.pdp__slide').forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.mediaId) === String(id)); });
      pdp.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
    }
    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    function update() {
      var chosen = [];
      pdp.querySelectorAll('[data-opt]:checked').forEach(function (r) {
        chosen[Number(r.dataset.opt)] = r.value;
        var label = pdp.querySelector('[data-opt-label="' + r.dataset.opt + '"]');
        if (label) label.textContent = r.value;
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return chosen[i] === undefined || o === chosen[i]; });
      });
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return;
      }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      compareEl.hidden = !onSale;
      if (onSale) compareEl.textContent = formatMoney(v.compare_at_price);
      wrap.classList.toggle('price--sale', !!onSale);
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) badge.textContent = '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    pdp.querySelectorAll('[data-opt]').forEach(function (r) { r.addEventListener('change', update); });

    pdp.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qty));
      });
    });

    /* AJAX add to cart, falls back to normal submit */
    if (form && window.fetch) form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name !== 'add') return;
      e.preventDefault();
      addBtn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var count = document.querySelector('[data-cart-count]');
          if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
          toast('Added to cart');
        })
        .catch(function (err) { toast((err && err.description) || "Couldn't add this item. Please try again."); })
        .finally(function () { addBtn.disabled = false; });
    });
  }

  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.querySelector('[data-toast-text]').textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 3500);
  }
})();
